var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8002_41031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37253 0 0 5.37253 0 12C0 18.6274 5.37253 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37253 18.6273 0 12 0ZM8.79836 17.8014H6.16364V9.2894H8.79836V17.8014ZM7.46845 8.17468C6.60798 8.17468 5.91041 7.47143 5.91041 6.60407C5.91041 5.73661 6.60807 5.03341 7.46845 5.03341C8.32882 5.03341 9.02638 5.73661 9.02638 6.60407C9.02643 7.47148 8.32887 8.17468 7.46845 8.17468ZM18.672 17.8014H16.05V13.3333C16.05 12.1078 15.5845 11.4238 14.6155 11.4238C13.5609 11.4238 13.01 12.1362 13.01 13.3333V17.8014H10.483V9.2894H13.01V10.4358C13.01 10.4358 13.7701 9.02975 15.575 9.02975C17.3799 9.02975 18.672 10.1318 18.672 12.4117L18.672 17.8014Z",
    fill: "url(#paint0_linear_8002_41031)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8002_41031",
    x1: 3.51471,
    y1: 3.51471,
    x2: 20.4852,
    y2: 20.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8002_41031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmLinkedin);
export default __webpack_public_path__ + "static/media/crm-linkedin.858da2bca5ea2da05d35c599f1d684f1.svg";
export { ForwardRef as ReactComponent };